import _ from 'lodash';

function getParam($route, key) {
    return _.toString(_.get($route, `params.${key}`));
}

function getName($route) {
    return _.get($route, `name`);
}

function getQuery($route, query) {
    return _.get($route, `query.${query}`);
}

function getParamOrQuery($route, key) {
    return getParam($route, key) || getQuery($route, key);
}

// eslint-disable-next-line import/prefer-default-export
export const lsRouterHelpers = {
    getParam,
    getName,
    getQuery,
    getParamOrQuery,
};
